<template>
  <main class="pp-page--ticket-quantity">
    <h1 class="title title--desktop">{{ $t('message.ticket_quantity_header') }}</h1>
    <div class="pp-layout-container pp-layout-container--single">
      <div class="pp-preamble">
        <h1 class="title title--mobile">{{ $t('message.ticket_quantity_header') }}</h1>
        <!-- Seat Level name not in spec here, but it's setup if needed down the line -->
        <!-- <h2 v-if="performance.seatLevelName.length > 0">{{ performance.seatLevelName }}</h2> -->
        <h2 v-if="performance.seatSectionName.length > 0">{{ performance.seatSectionName }}</h2>
      </div>
      <section class="pp-main-content">
        <p v-t="'message.ticket_quantity_body'" class="ticket-quantity__body"></p>
        <div class="ticket-quantity">
          <div class="ticket-quantity__wrapper ticket-quantity__decrement-wrapper">
            <span class="sr-only">{{ $t("ticket.remove_ticket") }}</span>
            <font-awesome-icon icon="minus-square"
              @click="decrementTicket" />
          </div>
          <input
            class="ticket-quantity__input"
            type="number"
            v-model="noOfTicketsSelected"
            placeholder="0"
          />
          <div class="ticket-quantity__wrapper ticket-quantity__increment-wrapper">
            <span class="sr-only">{{ $t("ticket.add_ticket") }}</span>
            <font-awesome-icon icon="plus-square"  @click="incrementTicket" />
          </div>
        </div>
        <div class="pp-actions">
          <div class="pp-actions__container">
            <error v-if="tooManySelected.length > 0">{{ tooManySelected }}</error>
            <fancy-button
              :text="$t('buttons.choose_seats')"
              @click.native="submit"
              :icon="['far', 'ticket-alt']"
              :disabled="noOfTicketsSelected < 1 || noOfTicketsSelected > 40"
            />
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import FancyButton from "@/components/generic/FancyButton";
import Error from "@/components/generic/Error"
import { mapActions, mapState } from 'vuex';

export default {
  name: "ticket-quantity",
  components: {
    FancyButton,
    Error
  },
  data() {
    return {
      noOfTicketsSelected: 0,
    };
  },
  watch: {
    "$i18n.locale": function() {
      this.retrieveTranslation();
    }
  },
  mounted() {
    this.clearError();
  },
  methods: {
    async retrieveTranslation() {
      await this.retrieveTranslatedSeatSection();
    },
    async submit() {
      if(this.noOfTicketsSelected > 0 && this.noOfTicketsSelected <= 40) {
        this.scrollToTopOfPurchasePath();
        await this.submitTicketQuantity(this.noOfTicketsSelected);
      } 
    },
    incrementTicket() {
      if(this.noOfTicketsSelected < 40) {
        this.noOfTicketsSelected++;
      }
    },
    decrementTicket() {
      if(this.noOfTicketsSelected > 0) {
        this.noOfTicketsSelected--;
      }
    },
    ...mapActions([
      'updateLoading', 
      'clearError', 
      'submitTicketQuantity', 
      'updateStage', 
      'scrollToTopOfPurchasePath', 
      'retrieveTranslatedSeatSection'
    ])
  },
  computed: {
    tooManySelected() {
      if(this.noOfTicketsSelected > 40) {
        return this.$t('errors.too_many_tickets');
      } else {
        return ""
      }
    },
    ...mapState(['performance'])
  }
};
</script>
